"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _componentsWeb = require("@telus-uds/components-web");
var _useStepTrackerContext = _interopRequireDefault(require("../hooks/useStepTrackerContext"));
var _constants = require("../constants");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var StepTrackerControls = props => {
  var {
    language = _constants.CONTENTFUL_LOCALE.en,
    fieldData = {},
    submitForm = () => {},
    continueButtonLabel = _constants.BUTTON_TEXT[language].continue,
    submitButtonLabel = _constants.BUTTON_TEXT[language].submit
  } = props;
  var {
    disableBackButton,
    showSubmitButton,
    OnNextStep,
    OnPreviousStep
  } = (0, _useStepTrackerContext.default)();
  var {
    back: backButtonText
  } = _constants.BUTTON_TEXT[language];
  return /*#__PURE__*/_react.default.createElement(_componentsWeb.Box, {
    flex: 1,
    horizontal: 3,
    bottom: {
      xs: 4,
      sm: 5,
      lg: 5,
      xl: 5
    },
    top: {
      xs: 6,
      sm: 7,
      lg: 7,
      xl: 7
    }
  }, /*#__PURE__*/_react.default.createElement(_componentsWeb.StackView, {
    direction: {
      xs: 'column',
      md: 'row'
    },
    space: 3,
    tokens: {
      alignItems: 'center',
      justifyContent: 'start'
    }
  }, /*#__PURE__*/_react.default.createElement(_componentsWeb.Button, {
    onPress: showSubmitButton ? () => {
      submitForm(fieldData);
    } : OnNextStep,
    variant: {
      width: 'responsive',
      priority: 'high'
    }
  }, showSubmitButton ? submitButtonLabel : continueButtonLabel), disableBackButton ? null : /*#__PURE__*/_react.default.createElement(_componentsWeb.Button, {
    onPress: OnPreviousStep,
    variant: {
      width: 'responsive'
    }
  }, backButtonText)));
};
StepTrackerControls.propTypes = {
  language: _propTypes.default.string,
  fieldData: _propTypes.default.object,
  submitForm: _propTypes.default.func
};
var _default = exports.default = StepTrackerControls;